import React from 'react'
import { User, Users, Link as LinkIcon } from 'lucide-react'
import { cn } from '@duck/ui'
import { useTar } from '@/modules/i18n'
import type { AssignmentKind } from '../cohortV2Data'

interface AssignmentTypeBadgeProps {
  kind: AssignmentKind
  className?: string
}

export const AssignmentTypeBadge: React.FC<AssignmentTypeBadgeProps> = ({ kind, className }) => {
  const { t } = useTar()
  const base = 'relative flex h-9 w-9 shrink-0 items-center justify-center rounded-lg border'
  if (kind === 'single') {
    return (
      <span className={cn(base, 'border-border bg-muted/40 text-muted-foreground', className)} aria-label={t('partner.typeSingle')}>
        <User className="h-[18px] w-[18px]" aria-hidden="true" />
      </span>
    )
  }
  if (kind === 'multi') {
    return (
      <span className={cn(base, 'border-border bg-muted/40 text-muted-foreground', className)} aria-label={t('partner.typeMulti')}>
        <Users className="h-[18px] w-[18px]" aria-hidden="true" />
      </span>
    )
  }
  // public
  return (
    <span className={cn(base, 'border-primary/30 bg-primary/10 text-primary', className)} aria-label={t('partner.typePublic')}>
      <Users className="h-[18px] w-[18px]" aria-hidden="true" />
      <span className="absolute -bottom-1 -end-1 flex h-[15px] w-[15px] items-center justify-center rounded-full border border-primary/60 bg-card text-primary">
        <LinkIcon className="h-[9px] w-[9px]" aria-hidden="true" />
      </span>
    </span>
  )
}
